import { CircleNotch } from 'phosphor-react';

const Spinner = ({ className, size }: { className?: string; size?: number }): JSX.Element => (
  <CircleNotch size={size} className={`inline animate-spin ${className ?? ''}`} />
);

export default Spinner;
